/**
 * Created by lzy 19-11-03
 * 企鹅号号渠道后台管理功能
 */
'use strict';
angular.module('productManageMentQiehaoModule', ['productManageMentQiehaoServiceModule'])
    . controller('productManageMentQiehaoCtrl', ['$scope', 'trsHttpService', 'modalDialog', 'productManageMentQiehaoService', 'permissionService', '$state', 'editcenterRightsService', 'productManageMentService',
        function($scope, trsHttpService, modalDialog, productManageMentQiehaoService, permissionService, $state, editcenterRightsService, productManageMentService) {
            initStatus();
            initData();
            $scope.$on('$destroy', function() {
                event = function() {};
            });

            /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
            function initStatus() {

                /**
             * [page description:分页信息]
             */
                $scope.page = {
                    'CURRPAGE': 1,
                    'PAGESIZE': 100,
                    'ITEMCOUNT': 0,
                    'PAGECOUNT': 1
                };
                $scope.status = {
                    copyCurrPage: 1,
                    params: {
                        'serviceid': 'mlf_kuaibaoaccount',
                        'methodname': 'query',
                        'AccountName': '',
                        'isActive': ''
                    },
                    isAdministrator: false,
                    rights: {},
                };
                $scope.data = {
                    items: [],
                    selectedArray: []
                };
                $scope.searchWord = '';

                /**
             * 判断是否是管理员
             */
                permissionService.isTenantAdministrator().then(function(data) {
                    $scope.status.isAdministrator = data;
                });
            }

            /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
            function initData() {
                requestData();
            }

            /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
            function requestData() {
                $scope.data.selectedArray = [];
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'get').then(function(data) {
                    !!data.DATA ? $scope.data.items = data.DATA : $scope.data.items = data;
                    !!data.PAGER ? $scope.page = data.PAGER : $scope.page.ITEMCOUNT = '0';
                });
            }

            /**
             * [initBtnRights description]初始化权限
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            function initBtnRights(item) {
                editcenterRightsService.initQieHaoListBtn('kuaibaoset.account', item.KUAIBAOACCOUNTID).then(function(data) {
                    item.rights = data;
                });
            }

            /**
             * [searchRequestData description]搜索
             *
             * @param   {[type]}  ev  [ev description]
             *
             * @return  {[type]}      [return description]
             */
            $scope.searchRequestData = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.status.params.AccountName = $scope.searchWord;
                    requestData();
                }
            };

            /**
             * [modifyAccount description]编辑账号信息
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.modifyAccount = function(item) {
                productManageMentQiehaoService.AccountAdd(item, function(result) {
                    if (result.result) {
                        modalDialog.alertType('编辑成功', '', 'success', false);
                        requestData();
                    } else if (result == 'successNeedConfirm') {
                        modalDialog.alertType('提示信息', '是否绑定完成？', 'ask', true, function() {
                            requestData();
                        });
                    } else {
                        modalDialog.alertType(result.detail, result.detail == result.message ? '' : result.message, 'error', false);
                    }
                });
            };

            /**
         * [create description] 新增企鹅号账号
         * @return {[type]} [description]
         */
            $scope.create = function() {
                productManageMentQiehaoService.AccountAdd('', function(result) {
                    if (result.result) {
                        modalDialog.alertType('创建成功', '', 'success', false);
                        requestData();
                    } else {
                        modalDialog.alertType('您的账号绑定企鹅号账号失败', result.data.message, 'error', false);
                    }
                });
            };

            /**
         * [sortAccount description] 微博账号排序
         * @return {[type]} [description]
         */
            // $scope.sortAccount = function() {
            //     if ($scope.data.selectedArray.length > 1) {
            //         modalDialog.alertType('请选择一个企鹅号账号', '', 'warning', false);
            //         return;
            //     } else {
            //         if ($scope.data.selectedArray[0].rights['kuaibaoset.account.edit']) {
            //             productManageMentQiehaoService.sort($scope.data.selectedArray[0], function(result) {
            //                 if (result == 'success') {
            //                     modalDialog.alertType('排序成功', '', 'success', false);
            //                     requestData();
            //                 } else {
            //                     modalDialog.alertType(result.detail, result.detail == result.message ? '' : result.message, 'error', 'confirm');
            //                 }
            //             });
            //         } else {
            //             modalDialog.alertType('该企鹅号账号没有编辑权限', '', 'error', false);
            //         }
            //     }
            // };

            /**
         * [revise description] 重置排序方法
         *
         * @return  {[type]}  [return description]
         */
            $scope.resetAccountOrder = function () {
                if ($scope.data.selectedArray.length > 1) {
                    modalDialog.alertType('请选择一个企鹅号', '', 'warning', false);
                    return;
                } else {
                    if ($scope.data.selectedArray[0].rights['kuaibaoset.account.edit']) {
                        productManageMentService.resetAccountOrder('qiehao', $scope.data.selectedArray[0], $scope.data.items, function (result) {
                            if (result == 'success') {
                                modalDialog.alertType('排序成功', '', 'success', false);
                                requestData();
                            } else {
                                modalDialog.alertType('排序失败', result.DETAIL, 'error', 'confirm');
                            }
                        });
                    } else {
                        modalDialog.alertType('该企鹅号账号没有编辑权限', '', 'error', false);
                    }
                }
            };
            
            /**
             * [deleteAccount description]删除方法
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.deleteAccount = function(item) {
                var tips = '';
                if (angular.isUndefined(item)) {
                    delete
                    weiboDeleteBatch();
                } else {
                    modalDialog.alertType('提示信息', '您确定要删除此企鹅号账号', 'ask', true, function() {
                        deleteQiehaoAccountMethod(item.KUAIBAOACCOUNTID);
                    });
                }
            };

            /**
         * [weiboDeleteBatch description] 企鹅号账号批量删除
         * @return {[type]} [description]
         */
            function weiboDeleteBatch() {
                var hasRightArr = [],
                    itemsArr = $scope.data.selectedArray,
                    item = '';
                for (var i = 0; i < itemsArr.length; i++) {
                    if (itemsArr[i].rights['kuaibaoset.account.delete']) {
                        hasRightArr.push(itemsArr[i]);
                    }
                }
                if (hasRightArr.length == 0) {
                    modalDialog.alertType('所选企鹅号账号没有删除权限', '', 'error', false);
                } else if (hasRightArr.length == itemsArr.length) {
                    var item = $scope.data.selectedArray.map(function(item) {
                        return item.KUAIBAOACCOUNTID;
                    }).join(',');
                    modalDialog.alertType('您确定要删除' + $scope.data.selectedArray.length + '个企鹅号账号', $scope.data.selectedArray.map(function(item) {
                        return item.ACCOUNTNAME;
                    }).join(','), 'ask', true, function() {
                        deleteQiehaoAccountMethod(item);
                    });
                } else {
                    item = hasRightArr.map(function(item) {
                        return item.KUAIBAOACCOUNTID;
                    }).join(',');
                    modalDialog.alertType('部分企鹅号账号没有删除权限，是否删除以下企鹅号账号', hasRightArr.map(function(item) {
                        return item.ACCOUNTNAME;
                    }).join(','), 'ask', true, function() {
                        deleteQiehaoAccountMethod(item);
                    });
                }
            }

            /**
             * [deleteQiehaoAccountMethod description]删除账号方法
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            function deleteQiehaoAccountMethod(item) {
                $scope.params = {
                    serviceid: 'mlf_kuaibaoaccount',
                    methodname: 'deleteAccounts',
                    ObjectIds: item
                };
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', $scope.params, 'get').then(function(data) {
                    modalDialog.alertType('删除成功', '', 'success', false);
                    requestData();
                });
            }

            /**
             * [pageChanged description]下一页
             *
             * @return  {[type]}  [return description]
             */
            $scope.pageChanged = function() {
                $scope.status.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [jumpToPage description]跳转到指定的一页
             *
             * @return  {[type]}  [return description]
             */
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.status.params.CurrPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };

            /**
         * [channelFormat description] 渠道显示格式化
         * @param  {[string]} platForm [description] 微博渠道
         * @return {[String]}      [description]
         */
            $scope.channelFormat = function(platForm) {
                if (platForm == 'sina' || platForm == 'Sina') {
                    return '新浪微博';
                } else {
                    return '';
                }
            };

            /**
         * [statusFormat description] 微博账号状态显示格式化
         * @param  {[string]} overtime [description] 账号状态
         * @return {[String]}        [description]
         */
            $scope.statusFormat = function(overtime) {
                var curTime = new Date();
                // 把字符串格式转化为日期类
                var endTime = new Date(Date.parse(overtime));
                if (curTime > endTime) {
                    return '延期失效';
                } else {
                    return '延期正常';
                }
            };

            /**
         * [watermarkMGR description]水印管理页面
         *
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  trench  [trench description]
         * @return  {[type]}        [return description]
         */
            $scope.watermarkMGR = function (item, trench) {
                productManageMentService.toWatermarkMGR(item, trench);
            };
            
            /**
         * [selectDoc description] 选择/取消选择微博
         * @param  {[Object]} item [description] 微博对象
         * @return {[type]}      [description]
         */
            $scope.selectDoc = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
            };

            /**
         * [selectAll description] 微博全选/全不选
         * @return {[type]} [description]
         */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            };

            /**
         * [itenInit description] 微博账号index值初始化
         * @param  {[Object]} item   [description] 微博账号
         * @param  {[Number]} $index [description] 微博顺序
         * @return {[type]}        [description]
         */
            $scope.itemInit = function(item, $index) {
                item.index = $index + 1 + ($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE;
                initBtnRights(item);
            };

            /**
         * [headPicload description] 头像未能正常显示时显示默认头像
         * @param  {[object]} item [description] 微博账号对象
         * @return {[type]}      [description]
         */
            $scope.headPicload = function(item) {
                var imgObj = new Image();
                imgObj.src = item.HEADPIC;
                imgObj.onload = function() {
                    item.picUrl = item.HEADPIC;
                };
                imgObj.onerror = function() {
                    item.picUrl = './images/user_icon.jpg';
                };
            };

            /**
             * [requestData description]挂载
             *
             * @return  {[type]}  [return description]
             */
            $scope.requestData = function () {
                requestData();
            };
        }
    ]);
